import { render, staticRenderFns } from "./DeductionTypes.vue?vue&type=template&id=30dc0a91"
import script from "./DeductionTypes.vue?vue&type=script&lang=js"
export * from "./DeductionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports